import React from 'react';
import { connect } from 'react-redux';
import { CallbackComponent } from 'redux-oidc';

import userManager from './userManager';
import { loginError, fetchUserInfo } from './actions';

class SigninCallbackPage extends React.Component {
  render() {
    let { returnPath, history, dispatch } = this.props;
    returnPath = returnPath || '/';

    return (
      <CallbackComponent
          userManager={userManager}
          successCallback={() => { dispatch(fetchUserInfo); history.replace(returnPath); }}
          errorCallback={error => {
            console.error(error);
            dispatch(loginError);
            history.push('/'); 
          }}
      >
        <div>Redirecting...</div>
      </CallbackComponent>
    );
  }
}


const mapStateToProps = state => ({
  returnPath: state.userManager.returnPath
});

export default connect(mapStateToProps)(SigninCallbackPage);